(function () {
    'use strict';

    angular
        .module('app.sso')
        .controller('RequestAccessController', RequestAccessController);

    /* @ngInject */
    function RequestAccessController($q, logger,
        ssoService,
        roleService,
        applicationService) {

        //Private Variables
        var vm = this;
        var applications = [];
        var roles = [];

        //Public Variables
        vm.requestAccess = {};
        vm.alerts = [];

        //Public Methods
        vm.sendRequestAccess = sendRequestAccess;

        activate();

        function activate() {
            var promises = [getApplications(), getRoles()];
            return $q.all(promises).then(function () {
                setForm(applications, roles);
                logger.info('Activated Request Access View');
            });
        }

        //Private Methods
        function getApplications() {
            return applicationService.getApplications()
                .then(function (result) {
                    applications = result;
                });
        }

        //Private Methods
        function getRoles() {
            return roleService.getRoles()
                .then(function (result) {
                    roles = result;
                });
        }

        function setForm(applications, roles) {
            vm.requestAccessFields = ssoService.getRequestAccessFields(applications, roles);
        }

        function sendRequestAccess() {
            if (vm.requestAccessForm.$valid) {
               return ssoService.sendRequestAccess(vm.requestAccess)
                    .then(function (result) {
                        if (result.status === 200) {
                            vm.alerts.push({msg: 'Request Sent!'});
                        } else {
                            logger.info('issue send Request for Access');
                        }
                    });
            }
        }
    }
})();
